import React, { useState } from 'react';
import '../App.css';
import axios from "axios";

//import axios from "axios";
import { Dropdown,  Modal } from 'react-bootstrap';
//import Mail_richiesta_dati from "./Alunno_x1_mail_dati";
//import DatePicker from "react-datepicker";
//import Alunno_Form_Base from "./Alunno_form_base";
import { AiOutlineMenuFold } from 'react-icons/ai';
import Tutor_Form_Base from "./Tutor_form_base";



const Nuovo_Tutor_Edit = (props) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [end_Date, set_End_Date] = useState(new Date());




    function cancellazione_tutor() {
        //        axios.post('http://localhost:3001/create', newNote)
        console.log(props.tutor._id)
        axios.delete('/tutor/cancella_tutor/' + props.tutor._id)
            .then((res) => {
                console.log(res.data)

            }).catch((error) => {
                console.log(error)
            });
        var aux = props.variab_aggiorna
        props.SET_variab_aggiorna(!aux)
    }

    return (
        <div class="d-flex flex-row-reverse">
            <Dropdown>
                <Dropdown.Toggle variant="Light" id="dropdown-basic">
                    Menu  <AiOutlineMenuFold />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {/* <Mail_richiesta_dati alunno={props.alunno} variab_aggiorna={props.variab_aggiorna} SET_variab_aggiorna={props.SET_variab_aggiorna} />  */} 

                    <Dropdown.Item onClick={handleShow} >Edit Tutor #da fare#</Dropdown.Item>
                    <Dropdown.Item onClick={cancellazione_tutor} >Cancella Tutor</Dropdown.Item>
                    <div class="dropdown-divider"></div>

                </Dropdown.Menu>
            </Dropdown>

            <Modal
                show={show}
                size="xl"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >

                <Modal.Dialog>
                    <Modal.Title id="example-custom-modal-styling-title">

                    </Modal.Title>
                    <Modal.Body>
                        <Tutor_Form_Base id={props.tutor._id} setShow={setShow} />
                    </Modal.Body>
                </Modal.Dialog>
            </Modal>
        </div>
    )
}

export default Nuovo_Tutor_Edit;
